import React from 'react';

const PrivacySecurityContent = () => {
  return (
    <main className="p-6 dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm dark:shadow-gray-900/50 p-8 transition-colors duration-300">
          <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-6 flex items-center transition-colors duration-300">
            <i className="fa-solid fa-shield-halved mr-3 text-blue-600 dark:text-blue-400 transition-colors duration-300"></i>
            Privacy & Security
          </h1>

          <div className="space-y-6 text-gray-700 dark:text-gray-300 transition-colors duration-300">
            <section>
              <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-3 transition-colors duration-300">Data Protection</h2>
              <p className="mb-3">
                At Tabulara, we take your data security seriously. All financial documents and data processed through our platform are protected with bank-grade encryption.
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>End-to-end encryption for all file uploads</li>
                <li>Secure data transmission using TLS 1.3</li>
                <li>Data is automatically deleted after processing</li>
                <li>No data is stored permanently on our servers</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-3 transition-colors duration-300">Privacy Policy</h2>
              <p className="mb-3">
                We are committed to protecting your privacy. This policy explains how we collect, use, and safeguard your information.
              </p>
              <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 transition-colors duration-300">
                <h3 className="font-semibold mb-2 text-gray-800 dark:text-white transition-colors duration-300">Information We Collect</h3>
                <ul className="list-disc list-inside space-y-1 ml-4 text-sm">
                  <li>Uploaded documents (temporarily for processing)</li>
                  <li>Usage analytics (anonymized)</li>
                  <li>API usage statistics</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-3 transition-colors duration-300">Security Measures</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-blue-50 dark:bg-blue-900/30 rounded-lg p-4 transition-colors duration-300">
                  <i className="fa-solid fa-lock text-blue-600 dark:text-blue-400 text-2xl mb-2 transition-colors duration-300"></i>
                  <h3 className="font-semibold mb-1 text-gray-800 dark:text-white transition-colors duration-300">Encryption</h3>
                  <p className="text-sm">AES-256 encryption for data at rest</p>
                </div>
                <div className="bg-blue-50 dark:bg-blue-900/30 rounded-lg p-4 transition-colors duration-300">
                  <i className="fa-solid fa-shield text-blue-600 dark:text-blue-400 text-2xl mb-2 transition-colors duration-300"></i>
                  <h3 className="font-semibold mb-1 text-gray-800 dark:text-white transition-colors duration-300">Access Control</h3>
                  <p className="text-sm">Role-based access control and authentication</p>
                </div>
                <div className="bg-blue-50 dark:bg-blue-900/30 rounded-lg p-4 transition-colors duration-300">
                  <i className="fa-solid fa-eye-slash text-blue-600 dark:text-blue-400 text-2xl mb-2 transition-colors duration-300"></i>
                  <h3 className="font-semibold mb-1 text-gray-800 dark:text-white transition-colors duration-300">Data Anonymization</h3>
                  <p className="text-sm">Personal data is anonymized during processing</p>
                </div>
                <div className="bg-blue-50 dark:bg-blue-900/30 rounded-lg p-4 transition-colors duration-300">
                  <i className="fa-solid fa-clock text-blue-600 dark:text-blue-400 text-2xl mb-2 transition-colors duration-300"></i>
                  <h3 className="font-semibold mb-1 text-gray-800 dark:text-white transition-colors duration-300">Auto Deletion</h3>
                  <p className="text-sm">Files automatically deleted after 24 hours</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-3 transition-colors duration-300">Compliance</h2>
              <p className="mb-3">
                Tabulara complies with international data protection regulations including:
              </p>
              <div className="flex flex-wrap gap-3">
                <span className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm text-gray-800 dark:text-gray-200 transition-colors duration-300">GDPR Compliant</span>
                <span className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm text-gray-800 dark:text-gray-200 transition-colors duration-300">SOC 2 Type II</span>
                <span className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm text-gray-800 dark:text-gray-200 transition-colors duration-300">ISO 27001</span>
                <span className="px-3 py-1 bg-gray-100 dark:bg-gray-700 rounded-full text-sm text-gray-800 dark:text-gray-200 transition-colors duration-300">PCI DSS</span>
              </div>
            </section>

            <section className="bg-blue-50 dark:bg-blue-900/30 border-l-4 border-blue-400 dark:border-blue-500 p-4 rounded transition-colors duration-300">
              <h3 className="font-semibold text-gray-800 dark:text-white mb-2 transition-colors duration-300">
                <i className="fa-solid fa-exclamation-triangle text-blue-600 dark:text-blue-400 mr-2 transition-colors duration-300"></i>
                Important Notice
              </h3>
              <p className="text-sm">
                Never share your API keys or credentials. Always use secure connections when accessing the platform.
              </p>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PrivacySecurityContent;

